module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAp0lEQVR4AdTS2w2AIAwFUHECR9BR3MiR3IRRdBO8NxJjEPpI+NHQ+ConpTAOna+fgymlI90xWztjWTKxCJh31dXAFcKJIGZCRTCEQMyFiiAqG7yoCgroxH9lmEBOqlS68XsZZrCc2Ho3g/nYREDccW7WjufPMIEVbM0t8IMejLpYoRdTQSS8e9ZcJvKeIVaYs7gBJoz5IojGLzmIMl8NEVRnVxK6gxcAAAD//5z3AiIAAAAGSURBVAMADbpGKWhQuJoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xiayibu_10@2x.png
// module id = 137
// module chunks = 1